/* ================= Baby Harmonie v3 — couche d'animations « signature » ================= */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var design = window.Shopify && Shopify.designMode;

  function ready(fn) { if (document.readyState === 'complete') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Transitions de page (rideau crème) */
  window.addEventListener('pageshow', function () { root.classList.remove('bh-leaving'); });

  ready(function () {
    if (reduce || !('IntersectionObserver' in window)) return;
    var anim = root.classList.contains('bh-anim');

    /* ---------- Observateur générique : ajoute .bh-on ---------- */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bh-on'); io.unobserve(e.target); if (e.target._bhOn) e.target._bhOn(); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    function watch(el, cb) { if (cb) el._bhOn = cb; io.observe(el); }

    /* ---------- Titres mot à mot ---------- */
    function split(el) {
      if (el.classList.contains('bh-split')) return;
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var parts = n.textContent.split(/(\s+)/);
            if (!n.textContent.trim()) return;
            var frag = document.createDocumentFragment();
            parts.forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'bh-w';
              var wi = document.createElement('span'); wi.className = 'bh-wi'; wi.style.setProperty('--i', i++);
              wi.textContent = p; w.appendChild(wi); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && !/^(BR|SVG|IMG)$/i.test(n.tagName)) { walk(n); }
        });
      })(el);
      el.classList.add('bh-split');
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
      watch(el);
    }
    if (anim) {
      $$('.bh-title, .section-header__title, .bh-cta h2, .bh-tab-panel h3, .bh-bundle__t, #MainContent .rte h2, #MainContent .theme-block h2, .template-product .product-single__title').forEach(split);
      $$('.bh-eyebrow').forEach(function (el) { el.classList.add('bh-ey'); watch(el); });
      $$('.bh-lead, .bh-tab-panel p').forEach(function (el) { el.classList.add('bh-fx'); watch(el); });

      /* ---------- Images en rideau ---------- */
      $$('.bh-tab-panel__img, .bh-pcard__img, .template-index .product__main-photos, .collection-item, .text-with-image__image, .feature-row__image').forEach(function (el) {
        el.classList.add('bh-curtain');
        var host = el.parentElement || el;
        var co = new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (e.isIntersecting) { el.classList.add('bh-on'); co.disconnect(); } });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
        co.observe(host);
      });

      /* ---------- Icônes dessinées ---------- */
      $$('.bh-card__icon svg, .bh-trust__icon svg').forEach(function (svg) {
        $$('path,circle,rect,polyline,line,ellipse,polygon', svg).forEach(function (s) { s.setAttribute('pathLength', '1'); });
        svg.classList.add('bh-draw'); watch(svg);
      });

      /* ---------- Étoiles des avis ---------- */
      $$('.testimonial-stars, .testimonials__stars, .icon-5-stars').forEach(function (el) { el.classList.add('bh-stars-wait'); watch(el); });

      /* ---------- Compteurs (01, 02, 03) ---------- */
      $$('.bh-step__num').forEach(function (el) {
        var target = parseInt(el.textContent, 10);
        if (isNaN(target)) return;
        var pad = el.textContent.trim().length;
        el.textContent = (pad > 1 ? '00' : '0').slice(0, pad);
        watch(el, function () {
          var t0 = null;
          function step(t) {
            if (!t0) t0 = t;
            var p = Math.min((t - t0) / 900, 1);
            var v = Math.round(target * (1 - Math.pow(1 - p, 3)));
            el.textContent = String(v).padStart(pad, '0');
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      });

      /* ---------- Pied de page en cascade ---------- */
      $$('.site-footer .grid__item').forEach(function (el, i) {
        el.classList.add('bh-reveal');
        el.style.setProperty('--bh-delay', (i * 0.1).toFixed(2) + 's');
        var o = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { el.classList.add('bh-in'); o.disconnect(); } }); });
        o.observe(el);
      });
    }

    /* ---------- Parallaxe + hero + bandeau défilant ---------- */
    var par = $$('.bh-tab-panel__img, .bh-pcard__img');
    par.forEach(function (el) { el.classList.add('bh-par'); });
    var hero = document.querySelector('.template-index .slideshow-wrapper, .template-index .hero');
    if (hero && !design) {
      var heroBox = hero.querySelector('.hero') || hero;
      var cue = document.createElement('span'); cue.className = 'bh-scroll-cue'; cue.setAttribute('aria-hidden', 'true');
      if (getComputedStyle(heroBox).position === 'static') heroBox.style.position = 'relative';
      heroBox.appendChild(cue);
    }
    var marqueeTracks = $$('.bh-marquee__track');
    var lastY = window.pageYOffset, vel = 0, raf = null;
    function frame() {
      var y = window.pageYOffset, vh = window.innerHeight;
      vel = vel * 0.85 + (y - lastY) * 0.15; lastY = y;
      par.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var c = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.setProperty('--bh-py', (c * -36).toFixed(1) + 'px');
      });
      if (hero) {
        var hh = hero.offsetHeight || 600;
        if (y < hh * 1.2) {
          hero.style.setProperty('--bh-hy', (y * 0.35).toFixed(1) + 'px');
          hero.style.setProperty('--bh-ho', Math.max(0, 1 - y / (hh * 0.75)).toFixed(3));
        }
      }
      marqueeTracks.forEach(function (t) {
        if (!t.getAnimations) return;
        var a = t.getAnimations()[0];
        if (a) a.playbackRate = 1 + Math.min(Math.abs(vel) / 6, 5);
      });
      raf = Math.abs(vel) > 0.2 ? requestAnimationFrame(frame) : null;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    frame();

    /* ---------- Survol : cartes 3D, halos, boutons magnétiques ---------- */
    if (fine) {
      $$('.bh-card, .bh-trust__item, .bh-pcard, .grid-product__content').forEach(function (card) {
        card.classList.add('bh-tilt');
        var g = document.createElement('span'); g.className = 'bh-glare'; g.setAttribute('aria-hidden', 'true');
        card.appendChild(g);
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          card.classList.add('bh-tilting');
          card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
          card.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 7).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 9).toFixed(2) + 'deg) translateY(-6px)';
        });
        card.addEventListener('mouseleave', function () {
          card.classList.remove('bh-tilting');
          card.style.transform = '';
        });
      });

      $$('.bh-cta').forEach(function (cta) {
        cta.addEventListener('mousemove', function (e) {
          var r = cta.getBoundingClientRect();
          cta.style.setProperty('--mx', (e.clientX - r.left) + 'px');
          cta.style.setProperty('--my', (e.clientY - r.top) + 'px');
        });
      });

      $$('.bh-btn, .hero__link .btn, .bh-tab-btn, .add-to-cart, .bh-cta .btn').forEach(function (b) {
        b.classList.add('bh-mag');
        b.addEventListener('mousemove', function (e) {
          var r = b.getBoundingClientRect();
          var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
          b.style.translate = (dx * 0.18).toFixed(1) + 'px ' + (dy * 0.3).toFixed(1) + 'px';
        });
        b.addEventListener('mouseleave', function () { b.style.translate = ''; });
      });
    }

    /* ---------- Onde au clic ---------- */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.btn, .bh-btn, .add-to-cart, .bh-tab-btn');
      if (!b) return;
      var r = b.getBoundingClientRect();
      var d = Math.max(r.width, r.height) * 2.2;
      var s = document.createElement('span');
      s.className = 'bh-ripple';
      s.style.width = s.style.height = d + 'px';
      s.style.left = (e.clientX - r.left - d / 2) + 'px';
      s.style.top = (e.clientY - r.top - d / 2) + 'px';
      if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
      b.appendChild(s);
      setTimeout(function () { s.remove(); }, 750);
    }, true);

    /* ---------- Vol de l'image vers le panier ---------- */
    function cartIcon() {
      var c = $$('.site-header .js-drawer-open-cart, .site-header a[href$="/cart"]').filter(function (el) { return el.offsetParent !== null; });
      return c[0];
    }
    function fly(fromImg) {
      var cart = cartIcon();
      if (!fromImg || !cart || !fromImg.animate) return;
      var a = fromImg.getBoundingClientRect(), b = cart.getBoundingClientRect();
      if (!a.width) return;
      var size = Math.min(a.width, 220);
      var clone = document.createElement('img');
      clone.src = fromImg.currentSrc || fromImg.src;
      clone.className = 'bh-fly';
      clone.style.width = clone.style.height = size + 'px';
      clone.style.left = (a.left + a.width / 2 - size / 2) + 'px';
      clone.style.top = (a.top + a.height / 2 - size / 2) + 'px';
      document.body.appendChild(clone);
      var tx = b.left + b.width / 2 - (a.left + a.width / 2);
      var ty = b.top + b.height / 2 - (a.top + a.height / 2);
      clone.animate([
        { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
        { transform: 'translate(' + tx * 0.55 + 'px,' + (ty * 0.55 - 120) + 'px) scale(.45) rotate(-8deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + tx + 'px,' + ty + 'px) scale(.08) rotate(10deg)', opacity: 0.4 }
      ], { duration: 950, easing: 'cubic-bezier(.55,0,.25,1)' }).onfinish = function () {
        clone.remove();
        cart.classList.remove('bh-bump'); void cart.offsetWidth; cart.classList.add('bh-bump');
      };
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('form[action*="/cart/add"] [name="add"], [data-bh-add]');
      if (!btn || btn.disabled) return;
      var scope = btn.closest('.bh-bdl, .product-section, [data-section-type="product"], #MainContent');
      var img = scope && scope.querySelector('.product-main-slide.is-selected img, .product__main-photos img, .bh-bdl__img img');
      if (!img) img = document.querySelector('#MainContent .product__main-photos img');
      fly(img);
    });

    /* ---------- Rideau de transition entre les pages ---------- */
    if (!design) {
      window.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
        if (a.closest('.drawer, .js-drawer-open-cart, [data-bh-bundle], .flickity-enabled')) return;
        var url;
        try { url = new URL(a.href, location.href); } catch (err) { return; }
        if (url.origin !== location.origin) return;
        if (url.pathname === location.pathname && url.search === location.search) return;
        e.preventDefault();
        root.classList.add('bh-leaving');
        try { sessionStorage.setItem('bhNav', '1'); } catch (err) {}
        setTimeout(function () { window.location.href = url.href; }, 420);
      });
    }
  });
})();
